package com.anjuros.website.templates.selection.modules

import com.anjuros.website.components.language.ResKey
import com.anjuros.website.templates.selection.util.Res


enum class Template(
    val icon: String,
    val imageDesc: ResKey,
    val title: ResKey,
    val description: ResKey,
    var link:String,
    var profession: ResKey,
    val header: ResKey?=null,
    val subheader: ResKey?=null
) {
    Template6(
        icon=Res.Image.template6_main,
        imageDesc = ResKey.TEMPLATE6,
        title = ResKey.TEMPLATE6,
        description = ResKey.TEMPLATE6_SUBTITLE,
        link="/electrician-website-design-uk",
        profession = ResKey.WORK_WITH_ELECTRICIAN_TITLE,
        header = ResKey.TEMPLATE6_HEADER,
        subheader = ResKey.TEMPLATE6_SUBHEADER
    ),
    Template4(
        icon=Res.Image.template4_main,
        imageDesc = ResKey.TEMPLATE4,
        title = ResKey.TEMPLATE4,
        description = ResKey.TEMPLATE4_SUBTITLE,
        link="/decorator-website-design-uk",
        profession = ResKey.WORK_WITH_PAINTER_TITLE,
        header = ResKey.TEMPLATE4_HEADER,
        subheader = ResKey.TEMPLATE4_SUBHEADER
    ),
    Template2(
        icon=Res.Image.template2_main,
        imageDesc = ResKey.TEMPLATE2,
        title = ResKey.TEMPLATE2,
        description = ResKey.TEMPLATE2_SUBTITLE,
        link="/handyman-website-design-uk",
        profession = ResKey.WORK_WITH_HANDYMAN_TITLE,
        header = ResKey.TEMPLATE2_HEADER,
        subheader = ResKey.TEMPLATE2_SUBHEADER
    ),
    Template1(
        icon= Res.Image.template1_main,
        imageDesc = ResKey.TEMPLATE1,
        title = ResKey.TEMPLATE1,
        description = ResKey.TEMPLATE1_SUBTITLE,
        link="/hairdresser-website-design-uk",
        profession = ResKey.WORK_WITH_HAIDRESSER_TITLE,
        header = ResKey.TEMPLATE1_HEADER,
        subheader = ResKey.TEMPLATE1_SUBHEADER
    ),

    Template9(
        icon=Res.Image.template9_main,
        imageDesc = ResKey.TEMPLATE9,
        title = ResKey.TEMPLATE9,
        description = ResKey.TEMPLATE9_SUBTITLE,
        link="/dog-walker-website-design-uk",
        profession = ResKey.WORK_WITH_DOGWALKER_TITLE,
        header = ResKey.TEMPLATE9_HEADER,
        subheader = ResKey.TEMPLATE9_SUBHEADER
    ),

    Template5(
        icon=Res.Image.template5_main,
        imageDesc = ResKey.TEMPLATE5,
        title = ResKey.TEMPLATE5,
        description = ResKey.TEMPLATE5_SUBTITLE,
        link="/baker-website-design-uk",
        profession = ResKey.WORK_WITH_BAKER_TITLE,
        header = ResKey.TEMPLATE5_HEADER,
        subheader = ResKey.TEMPLATE5_SUBHEADER
    ),

    Template10(
        icon=Res.Image.template10_main,
        imageDesc = ResKey.TEMPLATE10,
        title = ResKey.TEMPLATE10,
        description = ResKey.TEMPLATE10_SUBTITLE,
        link="/instructor-website-design-uk",
        profession = ResKey.WORK_WITH_INSTRUCTOR_TITLE,
        header = ResKey.TEMPLATE10_HEADER,
        subheader = ResKey.TEMPLATE10_SUBHEADER
    ),
    Template8(
        icon=Res.Image.template8_main,
        imageDesc = ResKey.TEMPLATE8,
        title = ResKey.TEMPLATE8,
        description = ResKey.TEMPLATE8_SUBTITLE,
        link="/pub-website-design-uk",
        profession = ResKey.WORK_WITH_PUB_TITLE,
        header = ResKey.TEMPLATE8_HEADER,
        subheader = ResKey.TEMPLATE8_SUBHEADER
    ),
//    TemplateMix(
//        icon=Res.Image.templatemix_main,
//        imageDesc =  ResKey.TEMPLATE_MIX,
//        title =  ResKey.TEMPLATE_MIX,
//        description =  ResKey.TEMPLATE_MIX_SUBTITLE,
//        link="/website-builder-for-uk-sole-trades",
//        profession = ResKey.WORK_WITH_HAIDRESSER_TITLE
//    )
}